import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import "./confirmation.css";
import "../../components/AceternityForm/AceternityForm.css";
import BorderGlow from "../../components/BorderGlow/BorderGlow";
import { registrarUsuario } from "../../services/posUsers";
import { createCheckUser } from "../../services/KitsLogin/posAndCheckUser";
import { posKitOrder } from "../../services/posOrders";
import { validateOrder } from "../../services/posOrders";
import { createInvoiceFromOrder, invoiceBanKAccountUpdate, validateInvoice } from "../../services/posInvoices";

const CheckoutForm = () => {
    // Retrieve data passed from KitCCCA
    const location = useLocation();
    const { price, nombre, selectedComponents, cantidadKits } = location.state || {};

    // Mapping kit names to Frappe Item codes (Sales Order line items require a
    // real Item Code to exist in Frappe, or order creation fails with
    // LinkValidationError: "Could not find Row #1: Item Code: ...")
    const kitMapping = {
        "Kit de CC/CA": "PD78GH",
        "Kit de Electronica Analogica": "PDD2D5",
        "Kit de Electronica Digital": "PD8AB6",
        "Kit de Mediciones Electricas": "PDA2CE",
        "Kit de Circuitos CE": "PDB50F",
    };
    const kitId = kitMapping[nombre];

    // Mapping kit prices based on type
    const kitPrices = {
        "Kit de CC/CA": {
            default: 16000,
            modified: 17100,
        },
        "Kit de Electronica Analogica": {
            default: 5000,
            modified: 7400,
        },
        "Kit de Electronica Digital": {
            default: 4000,
            modified: 4150,
        },
        "Kit de Mediciones Electricas": {
            default: 8000,
            modified: 10550,
        },
        "Kit de Circuitos CE": {
            default: 16500,
            modified: 18150,
        },
    };
    const currentKitPrice = kitPrices[nombre] || { default: 0, modified: 0 };

    // Mandatory components keys
    const componentesKeys = [
        "1 Protoboard",
        "1 Potenciómetro de 5K",
        "1 Inductor de 100mH",
        "3m de cable AWG22",
        "1 Cortadora",
        "6 capacitores",
        "4 Resistencias de potencia",
        "40 Resistencias",
        "Diodo de germanio",
        "Diodo zener",
        "5 diodos de silicio",
        "18 capacitores de poliester",
        "20 resistencias",
        "5 leds",
        "Transistor MOSFET",
        "2 Transistores BJT",
        "1 Amplificador operacional",
        "Compuerta NAND",
        "Compuerta AND",
        "Compuerta NOR",
        "Compuerta OR",
        "Compuerta NOT",
        "3 metros de cable AWG22",
        "Dip switch 4 posiciones",
        "4 resistencias de 330",
        "Led",
        "1 Potenciómetro de 1k",
        "2 capacitores",
        "4 diodos de silicio",
        "20 jumpers MM",
        "39 Resistencias",
        "8 capacitores",
        "3 capacitores electroliticos"

    ];

    // Extras object: id must be a real Frappe Item Code (see kitMapping comment above).
    const extras = {
        "Caja de herramientas": {
            id: "PDA832",
            price: 2500,
        },
        "Kit de puentes": {
            id: "PD9DA3",
            price: 2000,
        },
        "Multimetro": {
            id: "PD9300",
            price: 10000,
        },
        "3 metros de Cable": {
            id: "PDB917",
            price: 1200,
        },
        "Protoboard": {
            id: "PD2F94",
            price: 5000,
        },
    };

    // Determine if the kit is modified due to mandatory elimination
    const kitModified = componentesKeys.some(
        (key) => selectedComponents && selectedComponents[key] === false
    );
    // Determine if any extra is added
    const hasExtra = Object.keys(extras).some(
        (key) => selectedComponents && selectedComponents[key] === true
    );
    // For price calculation, use modified price if either a mandatory component is eliminated or an extra is added.
    const kitPricePerUnit = kitModified ? currentKitPrice.modified : currentKitPrice.default;

    // States for form fields
    const [nombreCompleto, setNombreCompleto] = useState("");
    const [carnet, setCarne] = useState("");
    const [numeroContacto, setNumeroContacto] = useState("");
    const [metodoPago, setMetodoPago] = useState("Efectivo");
    const [isProcessing, setIsProcessing] = useState(false);

    // Variables para los datos de TiloPay - ESTAS SON LAS VARIABLES QUE NECESITAS
    const [tiloPayName, setTiloPayName] = useState("");
    const [tiloPayLastName, setTiloPayLastName] = useState("");
    const [tiloPayEmail, setTiloPayEmail] = useState("");
    const [tiloPayAddress, setTiloPayAddress] = useState("");
    const [tiloPayProvince, setTiloPayProvince] = useState("");
    const [tiloPayPostalCode, setTiloPayPostalCode] = useState("");

    const navigate = useNavigate();

    // Provincias de Costa Rica
    const costaRicanProvinces = [
        "San José",
        "Alajuela", 
        "Cartago",
        "Heredia",
        "Guanacaste",
        "Puntarenas",
        "Limón"
    ];

    // Validar formato de código postal costarricense (5 dígitos)
    const validatePostalCode = (code) => {
        return /^\d{5}$/.test(code);
    };

    // Validar campos de TiloPay
    const validateTiloPayFields = () => {
        if (!tiloPayName.trim()) {
            alert("Por favor, ingrese su nombre para TiloPay.");
            return false;
        }
        if (!tiloPayLastName.trim()) {
            alert("Por favor, ingrese su apellido para TiloPay.");
            return false;
        }
        if (!tiloPayEmail.trim()) {
            alert("Por favor, ingrese su correo electrónico para TiloPay.");
            return false;
        }
        if (!tiloPayAddress.trim()) {
            alert("Por favor, ingrese su dirección para TiloPay.");
            return false;
        }
        if (!tiloPayProvince) {
            alert("Por favor, seleccione su provincia para TiloPay.");
            return false;
        }
        if (!tiloPayPostalCode.trim()) {
            alert("Por favor, ingrese su código postal para TiloPay.");
            return false;
        }
        if (!validatePostalCode(tiloPayPostalCode)) {
            alert("El código postal debe tener exactamente 5 dígitos.");
            return false;
        }
        return true;
    };

    const generateOrderNumber = (userId) => {
        const now = new Date();
        const timestamp = now.toISOString().replace(/[-:TZ.]/g, "").slice(0, 14);
        return `VOLTEON-${userId}-${timestamp}`;
    };

    const handleTiloPayRedirect = async (orderNumber, total, userData, tempData) => {
        try {
            // Guarda todos los datos que ocuparás tras volver
            localStorage.setItem("kit_temp_order", JSON.stringify({
                orderNumber,
                userData,
                line: tempData.line,
                discountProducts: tempData.discountProducts,
                additionalProducts: tempData.additionalProducts,
                totalPrice: total,
                nombreCompleto,
                carnet,
                numeroContacto,
                cantidadKits,
                nombre
            }));

            const response = await fetch("http://localhost:8000/createPayment", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    amount: Number(total).toFixed(2),
                    currency: "CRC",
                    // customerName: tiloPayName, Ejemplo de uso
                    customerName: nombreCompleto || "Cliente",
                    customerLastName: carnet || "000000",
                    customerEmail: "soporte@volteon.com",
                    customerPhone: numeroContacto || "88888888",
                    orderNumber,
                    redirectUrl: window.location.origin + "/kits/pago-confirmacion"
                }),
            });

            const result = await response.json();
            if (result?.url) {
                window.location.href = result.url;
                return;
            } else {
                throw new Error("No se obtuvo URL de TiloPay");
            }
        } catch (err) {
            console.error("Error al conectar con TiloPay:", err);
            alert("Error al conectar con TiloPay.");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsProcessing(true);

        // Si es pago con tarjeta, validar campos de TiloPay
        if (metodoPago === "Tarjeta" && !validateTiloPayFields()) {
            setIsProcessing(false);
            return;
        }

        const newUserData = {
            name: nombreCompleto,
            carne: carnet,
            numero: numeroContacto
        };

        let registeredUser;
        try {
            registeredUser = await createCheckUser(newUserData);
        } catch (error) {
            console.error("Error registering user:", error);
            setIsProcessing(false);
            return;
        }

        const userId = registeredUser?.id || 206;
        const mode_reglement_id = metodoPago === "SINPE" ? 106 : metodoPago === "Tarjeta" ? 6 : 4;

        const userDataForOrder = {
            socid: userId,
            mode_reglement_id
        };

        const line = {
            fk_product: kitId,
            qty: cantidadKits,
            subprice: kitPricePerUnit,
        };

        let discountProducts = [];
        let additionalProducts = [];

        if (kitModified) {
            const componentPrices = {
                "1 Protoboard": 5000,
                "1 Potenciómetro de 5K": 600,
                "1 Inductor de 100mH": 700,
                "3m de cable AWG22": 1250,
                "1 Cortadora": 3500,
                "6 capacitores": 750,
                "4 Resistencias de potencia": 1200,
                "40 Resistencias": 4000,
                "Diodo de germanio": 300,
                "Diodo zener": 300,
                "5 diodos de silicio": 750,
                "6 capacitores de poliester": 900,
                "20 resistencias": 2000,
                "5 leds": 1000,
                "Transistor MOSFET": 600,
                "2 Transistores BJT": 400,
                "1 Amplificador operacional": 700,
                "Compuerta NAND": 750,
                "Compuerta AND": 750,
                "Compuerta NOR": 750,
                "Compuerta OR": 750,
                "Compuerta NOT": 750,
                "3 metros de cable AWG22": 1200,
                "Dip switch 4 posiciones": 400,
                "4 resistencias de 330": 400,
                "Led": 150,
                "1 Potenciómetro de 1k": 600,
                "2 capacitores": 750,
                "4 diodos de silicio": 500,
                "20 jumpers MM": 1000,
                "39 Resistencias": 3900,
                "8 capacitores": 900,
                "3 capacitores electroliticos": 450,
            };

            componentesKeys.forEach((key) => {
                if (selectedComponents && selectedComponents[key] === false && componentPrices[key]) {
                    discountProducts.push({
                        label: key,
                        subprice: componentPrices[key],
                        qty: cantidadKits,
                    });
                }
            });
        }

        Object.keys(extras).forEach((key) => {
            if (selectedComponents && selectedComponents[key] === true) {
                additionalProducts.push({
                    id: extras[key].id,
                    qty: cantidadKits,
                    subprice: extras[key].price,
                });
            }
        });

        const total = price;

        try {
            if (metodoPago === "Tarjeta") {
                const orderNumber = generateOrderNumber(userId);
                await handleTiloPayRedirect(orderNumber, total, userDataForOrder, {
                    line,
                    discountProducts,
                    additionalProducts
                });
                return;
            } else {
                const orderId = await posKitOrder(userDataForOrder, line, discountProducts, additionalProducts);
                const ID = await validateOrder(orderId);
                navigate("/kits/confirmation", { state: { orderId: ID.name, totalPrice: price } });
            }
        } catch (error) {
            console.error("Error al procesar la orden:", error);
            setIsProcessing(false);
        }

    };
    
    if (isProcessing) {
        return (
            <div className="aceternity-form-page">
                <Header />
                <div className="aceternity-form-wrapper">
                    <BorderGlow className="aceternity-glow-wrap" borderRadius={16} backgroundColor="transparent">
                    <div className="aceternity-form-card" style={{ textAlign: "center" }}>
                        <h2 className="aceternity-form-title">Procesando la orden... Por favor espere</h2>
                    </div>
                    </BorderGlow>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="aceternity-form-page">
            <Header />

            <div className="aceternity-form-wrapper">
            <BorderGlow className="aceternity-glow-wrap" borderRadius={16} backgroundColor="transparent">
            <div className="aceternity-form-card">
                <h1 className="aceternity-form-title">Confirmación de pedido</h1>

                {/* Order Summary */}
                <div className="aceternity-summary">
                    <h2>Resumen del Pedido</h2>
                    <p>
                        <strong>Kit:</strong> {nombre}
                    </p>
                    <p>
                        <strong>Cantidad:</strong> {cantidadKits}
                    </p>
                    <p>
                        <strong>Total:</strong> ₡{price} colones
                    </p>
                    {(kitModified || hasExtra) && (
                        <>
                            <h3>Modificaciones:</h3>
                            <ul>
                                {componentesKeys.map((key) => {
                                    if (selectedComponents && selectedComponents[key] === false) {
                                        return (
                                            <li key={key}>
                                                {key}: Eliminado
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                                {Object.keys(extras).map((key) => {
                                    if (selectedComponents && selectedComponents[key] === true) {
                                        return (
                                            <li key={key}>
                                                {key}: Agregado
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                            </ul>
                        </>
                    )}
                </div>

                {/* Form for completing the order */}
                <form onSubmit={handleSubmit} className="aceternity-form">
                    <div className="aceternity-form-row">
                        <label className="aceternity-label">Nombre completo</label>
                        <input
                            className="aceternity-input"
                            type="text"
                            value={nombreCompleto}
                            name="name"
                            onChange={(e) => setNombreCompleto(e.target.value)}
                            required
                        />
                    </div>
                    <div className="aceternity-form-row">
                        <label className="aceternity-label">Carné</label>
                        <input
                            className="aceternity-input"
                            type="number"
                            value={carnet}
                            name="carnet"
                            onChange={(e) => setCarne(e.target.value)}
                            required
                        />
                    </div>
                    <div className="aceternity-form-row">
                        <label className="aceternity-label">Número de contacto</label>
                        <input
                            className="aceternity-input"
                            type="tel"
                            value={numeroContacto}
                            onChange={(e) => setNumeroContacto(e.target.value)}
                            required
                        />
                    </div>
                    <div className="aceternity-form-row">
                        <label className="aceternity-label">Método de pago</label>
                        <div className="aceternity-radio-row">
                            <label className="aceternity-radio-label">
                                <input
                                    type="radio"
                                    name="metodoPago"
                                    value="Efectivo"
                                    checked={metodoPago === "Efectivo"}
                                    onChange={(e) => setMetodoPago(e.target.value)}
                                />
                                Efectivo
                            </label>
                            <label className="aceternity-radio-label">
                                <input
                                    type="radio"
                                    name="metodoPago"
                                    value="SINPE"
                                    checked={metodoPago === "SINPE"}
                                    onChange={(e) => setMetodoPago(e.target.value)}
                                />
                                SINPE
                            </label>
                            {/* <label>
                                <input
                                    type="radio"
                                    name="metodoPago"
                                    value="Tarjeta"
                                    checked={metodoPago === "Tarjeta"}
                                    onChange={(e) => setMetodoPago(e.target.value)}
                                />
                                Tarjeta
                            </label> */}
                        </div>
                    </div>

                    {/* Formulario de datos para TiloPay */}
                    {metodoPago === "Tarjeta" && (
                        <div className="aceternity-summary">
                            <h3 style={{ textAlign: "center", marginTop: 0 }}>
                                Para realizar el pago con Tarjeta, por seguridad necesitamos que complete los siguientes espacios:
                            </h3>

                            <div className="aceternity-form-row">
                                <label className="aceternity-label">Nombre *</label>
                                <input
                                    className="aceternity-input"
                                    type="text"
                                    value={tiloPayName}
                                    onChange={(e) => setTiloPayName(e.target.value)}
                                    placeholder="Ingrese su nombre"
                                    required={metodoPago === "Tarjeta"}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <label className="aceternity-label">Apellido *</label>
                                <input
                                    className="aceternity-input"
                                    type="text"
                                    value={tiloPayLastName}
                                    onChange={(e) => setTiloPayLastName(e.target.value)}
                                    placeholder="Ingrese su apellido"
                                    required={metodoPago === "Tarjeta"}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <label className="aceternity-label">Correo electrónico *</label>
                                <input
                                    className="aceternity-input"
                                    type="email"
                                    value={tiloPayEmail}
                                    onChange={(e) => setTiloPayEmail(e.target.value)}
                                    placeholder="correo@ejemplo.com"
                                    required={metodoPago === "Tarjeta"}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <label className="aceternity-label">Dirección *</label>
                                <input
                                    className="aceternity-input"
                                    type="text"
                                    value={tiloPayAddress}
                                    onChange={(e) => setTiloPayAddress(e.target.value)}
                                    placeholder="Ej: 100 metros norte de la iglesia"
                                    required={metodoPago === "Tarjeta"}
                                />
                            </div>

                            <div className="aceternity-form-row">
                                <label className="aceternity-label">Provincia *</label>
                                <select
                                    className="aceternity-select"
                                    value={tiloPayProvince}
                                    onChange={(e) => setTiloPayProvince(e.target.value)}
                                    required={metodoPago === "Tarjeta"}
                                >
                                    <option value="" disabled>
                                        Seleccione su provincia
                                    </option>
                                    {costaRicanProvinces.map((province) => (
                                        <option key={province} value={province}>
                                            {province}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="aceternity-form-row">
                                <label className="aceternity-label">Código Postal *</label>
                                <input
                                    className="aceternity-input"
                                    type="text"
                                    value={tiloPayPostalCode}
                                    onChange={(e) => {
                                        // Solo permitir números y máximo 5 dígitos
                                        const value = e.target.value.replace(/\D/g, '').slice(0, 5);
                                        setTiloPayPostalCode(value);
                                    }}
                                    placeholder="Ej: 10101"
                                    required={metodoPago === "Tarjeta"}
                                />
                                <small className="aceternity-hint">
                                    Debe tener exactamente 5 dígitos
                                </small>
                            </div>

                            <p className="aceternity-hint" style={{ textAlign: "center" }}>
                                * Todos los campos son obligatorios
                            </p>
                        </div>
                    )}

                    <p className="aceternity-hint">
                        Importante: Verifique que todos los datos sean correctos antes de presionar el botón.
                        Una vez presionado, el pedido estará listo para recogerse.
                    </p>
                    <button type="submit" className="aceternity-btn-primary">
                        {metodoPago === "Tarjeta" ? "Proceder al pago con tarjeta" : "Enviar pedido"} &rarr;
                    </button>
                </form>
            </div>
            </BorderGlow>
            </div>

            <Footer />
        </div>
    );
};

export default CheckoutForm;